
import ShoppingCart from "../components/shopping-cart/ShoppingCart";
import Auth from "../libs/API/Auth";
import { gaSendEvent } from "../utils/Utils";
import { isMobileRes } from '../utils/Utils';

class UserMenuClass{
    constructor(){
        this.main = document.getElementById('user_menu');

        if(this.main == null){
            return;
        }
        
        this._mainBtn = this.main.querySelector('.main_btn');
        this._closeBtn = this.main.querySelector('.close_btn');
        this._logoutBtn = this.main.querySelector('.logout_btn');
        this._shoppingCartBtn = this.main.querySelector('.shopping_cart_btn');

        this._isOpen = false;

        this._mainBtn.addEventListener('click', this._onClickMainBtn.bind(this));
        this._closeBtn.addEventListener('click', this._onClickCloseBtn.bind(this));

        if (this._logoutBtn) {
            this._logoutBtn.addEventListener('click', this._onClickLogoutBtn.bind(this));
        }

        this.main.addEventListener('click', this.hide.bind(this));
        this.main.querySelector('.user-menu__column').addEventListener('click', e => e.stopPropagation());
        document.addEventListener('click', this._onClickDocument.bind(this));

        if (this._shoppingCartBtn) {
            this._shoppingCartBtn.addEventListener('click', this._onClickShoppingCartBtn.bind(this));
            ShoppingCart.addEventListener('cartChange', this._onShoppingCartChange.bind(this));
        }
    }

    show(){
        this._isOpen = true;
        document.body.classList.add('user-menu--show');

        setTimeout(() => {
            document.body.classList.add('user-menu--in');
        }, 50);
    }

    hide(){
        this._isOpen = false;
        document.body.classList.remove('user-menu--in');

        const timeoutAnimation = isMobileRes() ? 750 : 0;

        setTimeout(() => {
            document.body.classList.remove('user-menu--show');
        }, timeoutAnimation);
    }

    _onShoppingCartChange() {
        if(ShoppingCart.itemsCount == 0){
            this._shoppingCartBtn.classList.remove('button--bubble-show');
        }else{
            this._shoppingCartBtn.classList.add('button--bubble-show');
        }
    }

    _onClickShoppingCartBtn(e) {
        e.preventDefault();

        gaSendEvent('User menu', 'Click My List', 'User menu My List');
        
        this.hide();

        setTimeout(() => {
            ShoppingCart.show();
        }, 350);
    }

    _onClickMainBtn(e){
        e.stopPropagation();

        if(this._isOpen){
            this.hide();
        }else{
            this.show();
        }
    }

    _onClickCloseBtn(e){
        this.hide();
    }

    _onClickLogoutBtn(e){
        e.preventDefault();
        
        Auth.logout();
    }

    _onClickDocument(e){
        this.hide();
    }
}

const UserMenu = new UserMenuClass();
Object.seal(UserMenu);

export default UserMenu;